export default {
  teamTitle: 'Únete a nuestro equipo',
  teamText: `Cultivamos la excelencia,\nal igual que lo hacemos con nuestras levaduras.`,
  info: `Via Verdi,\n32 31046 Oderzo - TV\nItalia`,
}
